export default {
  props: {
    required: { type: Boolean, default: false },
  },
}
